<template>
  <div class="yes-tooltip p-0" @mouseover="active = true" @mouseleave="active = false">
    <template v-if="$slots.default">
      <slot />
    </template>
    <span v-show="active" class="yes-tooltip__content text-base" :style="`${top&&right?`top:${top}rem;right:${right}rem;left:${left || 0}rem;border-top-left-radius:${topleft}px;border-bottom-left-radius:${bottomleft}px;border-top-right-radius:${topright}px;`:``}`">
      <slot name="content" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'YesTooltip',
  props: {
    top: {
      type: Number,
      default: null
    },
    right: {
      type: Number,
      default: null
    },
    left: {
      type: Number,
      default: null
    },
    topleft: {
      type: Number,
      default: 10
    },
    bottomleft: {
      type: Number,
      default: 0
    },
    topright: {
      type: Number,
      default: 10
    }
  },
  data: () => ({
    active: false
  })
}
</script>

<style scoped lang="scss">
  .yes-tooltip {
    position: relative;
    cursor: pointer;
    display: inline-block;
    .yes-tooltip__content {
      position: absolute;
      top: -2.3rem;
      background: #2F80ED;
      border-radius: 10px 10px 10px 0;
      color: #fff;
      padding: .5rem;
      display: block;
      right: -7rem;
      z-index: 99999;
      font-family: "Rubik Regular", sans-serif;
    }
  }
</style>
